<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <zv-table :table="table" ref="dataTable">
          <div slot="ctrl-button">
            <el-button type="primary" @click="doAdd()">新增</el-button>
          </div>
        </zv-table>
      </div>
    </div>
  </div>
</template>
<script>
import api from "./api";
import TipUtil from "@/utils/utils/TipUtil";
import addFormMixin from "@/mixins/addFormMixin";
export default {
  name: "AppList",
  mixins: [addFormMixin],
  components: {
  },
  data() {
    let vm = this;
    return {
      table: {
        api: api.epidemicList,
        query: {

        },
        searchData: [
          {
            // type: "input",
            // model: "app_name",
            // placeholder: "App名称"
          }
        ],
        columns: [
          {
            title: "地区名称",
            key: "area_name",
            minWidth:"150",
            showTooltip: true
          },
          {
            title: "基础信息",
            minWidth:"150",
            render(h, ctx) {
              let status = ctx.index;
              let statusText;
              if (status == 0) {
                statusText  = "--";
              } else {
                statusText = "修改"
              }
              const editBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.goBasePages.bind(this, ctx.row.id)
                  }
                },statusText)
              let arr = [];
              arr.push(editBtn);
              return h("span", arr);
            }
          },
          {
            title: "疫情数据",
            minWidth:"150",
            render(h, ctx) {
              const editBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.epidemicDatas.bind(this, ctx.row.id)
                  }
                },
                "修改"
              );
              let arr = [];
              arr.push(editBtn);
              return h("span", arr);
            }
          },
          {
            title: "操作人",
            key: "last_admin_username",
            minWidth: "60",
            render(h, ctx) {
              let status = ctx.row.last_admin_username;
              let statusText;
              if (status == "") {
                statusText = "--";
              } else {
                statusText = status;
              }
              return h("span", statusText);
            }
          }
        ]
      },
      
      adddApi: api.addApp,
      editApi: api.editApp,
      deleteApi: api.deleteApp,
    };
  },

  created() {

  },


  methods: {
    goBasePages(id) {
      if(id == 1) {
        TipUtil.message("全球基础信息不能修改！", "error");
      }else {
        let routeData = this.$router.resolve("/epidemic/baseInformation?id=" + id);
        window.open(routeData.href, '_blank');
      }
    },
    epidemicDatas(id) {
      let routeData = this.$router.resolve("/epidemic/epidemicDatas?id=" + id);
      window.open(routeData.href, '_blank');
    }
  },

  mounted() {

  },
  beforeDestroy() {

  }
};
</script>

<style lang="less" scoped>

</style>
